import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BrowserRouter as Router } from 'react-router-dom';

import AppContext from './AppContext';
import dataManager from './DataManager';
import Login from './components/Login';
import ContentView from './components/ContentView';

function App() {
  const { t, i18n } = useTranslation();

  const [user, setUser] = useState(null);

  const contextValue = {
    t, i18n, user
  };

  useEffect(() => {
    const unsubscribe = dataManager.onAuthStateChanged((user) => {
      setUser(user);
    });

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, []);

  return (
    <AppContext.Provider value={contextValue}>
      <Router>
        {user ? <ContentView /> : <Login />}
      </Router>
    </AppContext.Provider>
  );
}

export default App;
